<template>
  <div>
  <div v-if="showPopup" class="word-popup grey">
    <b-container>
      <b-row>
        <b-col>
          <h2>{{currentWord}}</h2>
          <p v-html="currentWordDescription"></p>
          <b-button class="btn-round btn-black mt-5" @click="showPopup=false">JATKA</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <b-container fluid>
    <b-row :class="game==='wheel' ? 'green top' : 'blue top'">
      <b-col>
        <b-container class="pb-3">
        <b-row>
          <b-col cols="3" class="text-left">
            <Heart v-if="lives > 0" class="mr-1" />
            <Heart v-if="lives > 1" class="mr-1" />
            <Heart v-if="lives > 2" />
          </b-col>
          <b-col cols="6" class="text-center pt-3 ">
            <div class="progress-wrapper">
              <div :class="n > round ? 'progress' : 'progress filled'" v-for="n in rounds" v-bind:key="n"></div>
            </div>
            <div class="mt-2">pisteet: {{ score }}</div>
          </b-col>
          <b-col cols="3" class="text-right end-game">
            <router-link to="/"><span class="d-none d-lg-block mr-3 mt-2">Lopeta peli</span></router-link>
            <router-link to="/">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon-close"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
            </router-link>
          </b-col>
        </b-row>
        </b-container>
      </b-col>
    </b-row>

    <b-row :class="game==='wheel' ? 'green' : 'blue'">
      <b-col cols="12" class="text-center">
        <b-container class="wrapper">
          <b-row>
            <b-col lg="8" offset-lg="2">
              <!-- <h1 v-if="gamestate == 'intro'">ONNENPYÖRÄ</h1> -->
              <div class="game-wrap">
                <WheelOfFortune v-if="game==='wheel'"  @done="wheelDone" ref="wheel" />
                <SlotMachine v-if="game==='slots'" @done="slotDone" ref="slots" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <b-row class="grey">
      <b-col md="3" class="d-none d-md-block">
        <img v-if="gamestate=='question'" src="../assets/c-mic.png" class="c-hahmo" />
      </b-col>
      <b-col md="6" class="text-center pt-4 main-column">
        <template v-if="gamestate=='question'">
          <div class="py-3">
            <span :class="color + ' jackpot'">{{ jackpot }} pistettä</span>
          </div>
          <p class="question py-4 mb-0 text-center" v-html="formatText(currentQuestion.question)"></p>
          <b-button class="btn-round btn-green mr-md-5" @click="answer(true)">OIKEIN</b-button>
          <b-button class="btn-round btn-red" @click="answer(false)">VÄÄRIN</b-button>
        </template>
        <h2 v-if="gamestate==='right'" class="mb-3">Hienoa!</h2>
        <h2 v-if="gamestate==='wrong'" class="mb-3">Hmm. Nyt meni väärin.</h2>
        <p class="question text-center" v-if="gamestate=='wrong' || gamestate=='right'" v-html="formatText(currentQuestion.description)"></p>
        <template v-if="gamestate==='intro'">
          <p v-if="game==='wheel'">Pyöritä onnenpyörää ja<br/>testaa tietosi tekijänoikeuksista.</p>
          <p v-if="game==='slots'">Pelaa hedelmäpeliä ja<br/>testaa tietosi tekijänoikeuksista.</p>
        </template>
        <template v-if="gamestate==='unlucky'">
          <p v-if="game==='wheel'" class="question mt-5 text-center">Rosvosektori.<br/>Menetät yhden elämän.</p>
          <p v-if="game==='slots'" class="question mt-5 text-center">Ohi.<br/>Pyöritä uudestaan.</p>
        </template>
        <b-button class="btn-round btn-black mt-5" @click="spin" v-if="canSpin">PYÖRITÄ</b-button>
        <template v-if="this.lives===0">
          <p class="question mt-5 text-center">Peli päättyi. Yritä uudestaan.</p>
          <b-button class="btn-round btn-black" @click="resetGame">PELAA UUDESTAAN</b-button>
          <router-link to="/"><b-button class="btn-round btn-black">LOPETA PELI</b-button></router-link>
        </template>
        <template v-if="this.round===this.rounds">
          <h2 class="mt-5">Läpäisit pelin, hienoa!</h2>
          <p class="question py-3 completed text-center">Sait kasaan {{ score }} pistettä.</p>
          <b-button class="btn-round btn-black" @click="resetGame">PELAA UUDESTAAN</b-button>
          <router-link to="/"><b-button class="btn-round btn-black">LOPETA PELI</b-button></router-link>
        </template>
        <!-- <p>{{ gamestate }}</p> -->
      </b-col>
      <b-col v-if="gamestate=='wrong' || gamestate=='right'" md="3" class="d-none d-md-block">
        <img v-if="game==='wheel'" src="../assets/c-books.png" class="c-hahmo" />
        <img v-if="game==='slots'" src="../assets/c-music.png" class="c-hahmo" />
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>

<script>
import WheelOfFortune from '@/components/WheelOfFortune.vue'
import SlotMachine from '@/components/SlotMachine.vue'
import Heart from './Heart.vue'

export default {
  name: 'Game',
  components:
  {
    WheelOfFortune,
    SlotMachine,
    Heart
  },
  props: {
    game: String
  },
  data: function () {
    return {
      score: 0,
      jackpot: 0,
      color: null,
      lives: 0,
      rounds: 10,
      round: 0,
      gamestate: 'intro',
      questions: [],
      currentQuestion: null,
      showPopup: false,
      currentWord: 'Word',
      currentWordDescription: '',
      dictionary: [
        {'word': 'Creative Commons –lisenssi', 'match': 'cc', 'meaning': 'Tekijä voi laittaa teokseensa CC-lisenssin. CC-lisenssi tarkoittaa, että tekijä antaa luvan käyttää teosta tietyillä ehdoilla. CC-lisenssillä tekijä voi antaa luvan esimerkiksi oman teoksen jakamiseen tai muokkaamiseen.'},
        {'word': 'Julkinen esittäminen', 'match': 'julkinen', 'meaning': 'Julkinen esittäminen tarkoittaa, että teosta (esimerkiksi elokuvaa) näytetään yleisölle.'},
        {'word': 'Julkinen paikka', 'match': 'julkisella', 'meaning': 'Julkinen paikka on paikka, jonne kaikki saavat mennä. Julkisia paikkoja ovat esimerkiksi kirjastot ja puistot.'},
        {'word': 'Laki / laillinen / laiton', 'match': 'laittomasti', 'meaning': 'Laki on valtion sääntö, jota pitää noudattaa. Jos teko noudattaa lakia, se on laillinen. Jos teko rikkoo lakia, se on laiton. Jos rikkoo lakia, saa rangaistuksen. Lain mukaan tekijänoikeuksia pitää noudattaa.'},
        {'word': 'Laki / laillinen / laiton', 'match': 'laillisesti', 'meaning': 'Laki on valtion sääntö, jota pitää noudattaa. Jos teko noudattaa lakia, se on laillinen. Jos teko rikkoo lakia, se on laiton. Jos rikkoo lakia, saa rangaistuksen. Lain mukaan tekijänoikeuksia pitää noudattaa.'},
        {'word': 'Luova työ', 'match': 'luova', 'meaning': 'Luova työ on sellaista työtä, johon ihminen käyttää omia ideoitaan ja taitojaan. Luovan työn tulos voi olla esimerkiksi tarina, maalaus, elokuva tai musiikkia. Luovan työn tulos ei ole koskaan kopio toisen työstä.'},
        {'word': 'Lähde', 'match': 'lähde', 'meaning': 'Lähde tarkoittaa sitä paikkaa, josta esimerkiksi teksti tai tieto on otettu. Lähde voi olla esimerkiksi kirja, internetsivu tai ihminen. Lähde pitää aina ilmoittaa. Tämä tarkoittaa, että pitää esimerkiksi kertoa, mitä internetsivua tai kirjaa on käyttänyt. Tekijän nimi pitää aina kertoa, kun käyttää esimerkiksi toisen tekstiä tai kuvaa.'},
        {'word': 'Perillinen', 'match': 'perilli', 'meaning': 'Perillinen on se ihminen, jolle kuolleen ihmisen omaisuus siirtyy. Perillisiä on usein monta.'},
        {'word': 'Tekijänoikeus', 'match': 'tekijänoikeu', 'meaning': 'Tekijänoikeus tarkoittaa sitä, että tekijä saa suojaa omalle työlleen. Tekijänoikeuksien vuoksi toisen teosta ei saa käyttää vapaasti.'},
        {'word': 'Tekijä', 'match': 'tekij', 'meaning': 'Ihminen, joka on tehnyt luovan teoksen.'},
        {'word': 'Teoskynnys', 'match': 'teoskynny', 'meaning': 'Kaikki työt eivät saa tekijänoikeussuojaa. Silloin sanotaan, että teos ei ylitä teoskynnystä. Jos piirrät paperille viivan kynällä, se ei ylitä teoskynnystä. Teoksen pitää olla omaperäinen ja itsenäinen. - Itsenäinen = teos ei ole toisen teoksen kopio. - Omaperäinen = teoksessa näkyy tekijänsä persoonallinen jälki.'},
        {'word': 'Teos', 'match': 'teo', 'meaning': 'Teos on luovan työn tulos. Teos voi olla esimerkiksi kirjoitus, kuvataidetyö, video tai musiikkia.'},
        {'word': 'Yksityinen käyttö', 'match': 'yksityinen käyttö', 'meaning': 'Yksityinen käyttö tarkoittaa, että käyttää jotain vain yksin, perheen tai läheisten kavereiden kanssa.'}
      ]
    }
  },
  watch: {
  },
  methods: {
    resetGame: function () {
      this.gamestate = 'intro'
      this.lives = 3
      this.score = 0
      this.round = 0
      this.jackpot = 0
    },
    spin: function () {
      this.gamestate = 'spinning'
      if (this.game === 'wheel') {
        this.$refs.wheel.spin()
      }
      if (this.game === 'slots') {
        this.$refs.slots.spin()
      }
    },
    wheelDone: function (result) {
      this.color = result
      this.jackpot = this.jackpotSize(result)
      if (result === 'black') {
        this.lives--
        this.gamestate = 'unlucky'
      } else {
        this.nextQuestion()
        this.gamestate = 'question'
      }
    },
    slotDone: function (result) {
      if (result > 0) {
        this.jackpot = result
        this.nextQuestion()
        this.gamestate = 'question'
      } else {
        this.gamestate = 'unlucky'
      }
    },
    answer: function (val) {
      if (val === this.currentQuestion.answer) {
        this.gamestate = 'right'
        this.score += this.jackpot
      } else {
        this.gamestate = 'wrong'
        this.lives--
      }
      this.round++
    },
    fetchQuestions: function () {
      let slug = 'onnenpyora'
      if (this.game === 'slots') {
        slug = 'hedelmapeli'
      }
      let params = {
        'per_page': 50,
        'filter[kysymystyyppi]': slug
      }
      this.axios
        .get('https://kopiraittila.fi/wp-json/wp/v2/helpolla-suomella', {params})
        .then(response => {
          this.questions = response.data
          // console.debug('fetched ' + response.request.responseURL )
        })
        .catch(error => {
          console.error(error)
        })
    },
    nextQuestion: function () {
      let random = Math.floor(Math.random() * this.questions.length)
      let question = this.questions.splice(random, 1)[0]
      this.currentQuestion = {question: question.acf.vaittama, answer: question.acf.totta, description: question.acf.palaute}
      if (this.questions.length === 0) {
        this.fetchQuestions()
      }
    },
    jackpotSize: function (color) {
      if (color === 'keltainen') { return 10 }
      if (color === 'punainen') { return 20 }
      if (color === 'vihrea') { return 30 }
      if (color === 'sininen') { return 50 }
      if (color === 'violetti') { return 100 }
      return 0
    },
    formatText: function (text) {
      // split to words
      let words = text.split(' ')
      let result = ''
      words.forEach(word => {
        result += this.formatWord(word)
      })
      return this.splitToLines(result)
    },
    formatWord: function (word) {
      this.dictionary.forEach(item => {
        if (word.toLowerCase().indexOf(item.match) === 0) {
          console.debug(word + ' ' + item.match)
          word = '<a href="#" onClick="event.preventDefault();showDictionary(\'' + item.word + '\');">' + word + '</a>'
        }
      })
      word = word + ' '
      return word
    },
    splitToLines: function (text) {
      return text.replaceAll('. ', '.<br/>').replaceAll(', ', ',<br/>')
    },
    showDictionary: function (word) {
      console.debug(word)
      this.currentWord = word
      this.dictionary.forEach(item => {
        if (item.word === word) {
          this.currentWordDescription = this.splitToLines(item.meaning)
        }
      })
      this.showPopup = true
    }
  },
  computed: {
    canSpin: function () {
      if (this.questions.length === 0) { return false }
      if (this.lives === 0) { return false }
      if (this.round === this.rounds) { return false }
      if (this.gamestate === 'intro') { return true }
      if (this.gamestate === 'right') { return true }
      if (this.gamestate === 'wrong') { return true }
      if (this.gamestate === 'unlucky') { return true }
      return false
    }
  },
  created: function () {
    this.resetGame()
    this.fetchQuestions()
    window.scrollTo(0, 0)
    window.showDictionary = this.showDictionary.bind(this)
  }
}
</script>

<style>
  .wrapper{
    max-height: 50vh;
  }
  .game-wrap {
    margin: 0 auto;
    padding: 0;
  }
  .top{
    padding-top: 20px;
  }
  @media (min-width: 992px) {
    .top{
      padding-top: 80px;
    }
  }
  @media (min-width: 1280px) {
    .top{
      padding-top: 200px;
    }
  }
  .green {
    background-color: #88B87C;
    color: #FCF9F9;
    font-weight: 700;
  }
  .blue {
    background-color: #4E96CA;
    color: #FCF9F9;
    font-weight: 700;
  }
  .grey {
    font-weight: 700;
  }
  .end-game{
    display: flex;
    justify-content: flex-end;
    align-items: top;
  }
  .main-column{
    min-height: 400px;
  }
  h2{
    font-size: 1.4em;
    font-weight: 700;
    text-transform: uppercase;
  }
  p{
    font-size: 1.2em;
  }
  .btn-close{
    color: #FCF9F9;
    font-weight: 700;
  }
  .icon-close{
    width: 40px;
    margin-right: 10px;
    fill: #FCF9F9;
  }
  .c-hahmo{
    width: 100%;
    height: auto;
  }
  .progress-wrapper{
    display: flex;
    justify-content: center;
  }
  .progress{
    width: 30px;
    height: 15px;
    margin: 0 2px;
    background-color: #FCF9F9;
    float: left;
    opacity: 0.25;
  }
  .completed{
    color: #009DF6;
  }
  .filled{
    opacity: 1;
  }
  .jackpot{
    padding: 1em;
  }
  .keltainen{
    background-color: #FFBC25;
  }
  .punainen{
    background-color: #FF4E4F;
  }
  .vihrea{
    background-color: #30BD7A;
  }
  .sininen{
    background-color: #009DF6;
  }
  .violetti{
    background-color: #D378B5;
  }
  .word-popup{
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 20;
    width: 100%;
    height: 100vh;
    background-color: #F2EFEF;
  }
  a{
    color: #000;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Game.vue